import { Accordion, Col, Container, Row } from "react-bootstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useEffect, useState } from "react";

export default function KIYGGames() {
  const [GAMES, setGAMES] = useState([]);

  useEffect(() => {
    async function fetchGames() {
      const games = await fetch("data/kiyg25-games-data.json");
      const gamesList = await games.json();
      setGAMES(gamesList);
    }
    fetchGames();
  }, []);

  return (
    <>
      {/* list of bootstrap accordions */}
      <Breadcrumb
        pageName={KIYGGames}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      <Container>
        <Accordion defaultActiveKey={"0"}>
          <Row>
            {GAMES?.map((game, index) => (
              <Col md={4}>
                <Accordion.Item
                  className="col-md-4"
                  eventKey={`${index}`}
                  key={index}
                  style={{
                    margin: 20,
                    padding: 20,
                    width: "100%",
                    backgroundColor: "#0b244d",
                    color: "white",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <Accordion.Header style={{ color: "white" }}>
                    {game.title}
                  </Accordion.Header>
                  <Accordion.Body
                    style={{
                      margin: 5,
                      padding: 5,
                      backgroundColor: "#0b244d",
                      color: "white",
                      borderRadius: "8px",
                    }}
                  >
                    {game.description}
                  </Accordion.Body>
                </Accordion.Item>
              </Col>
            ))}
          </Row>
        </Accordion>
      </Container>
    </>
  );
}
